<template src="./templates/index.html" />

<script type="text/ecmascript-6">
import {mapGetters} from 'vuex'
import {FouSelectObject} from 'src/utils/objects/fou-select'
import FouDropdown from 'components/form/fou-dropdown/'
import { useForm } from 'vee-validate'
import { errors as submissionErrors } from 'src/pages/submissions/script/common.data'
import { isEmpty } from 'lodash'
import Misc from 'src/utils/helper/misc'
import { getFoundrySubTitle, attemptFoundrySwitch, getSessionFoundrySelectValues } from 'src/utils/helper/contractTermination'

export default {
  name: 'foundry-dropdown',

  data () {
    return {
      foundry: FouSelectObject(),
      foundries: [],
      foundryLoaded: false,
      permissionsFoundryList: [],
      validSelectedFoundry: {}
    }
  },

  components: {
    FouDropdown
  },

  props: {
    searchable: {
      type: Boolean,
      default: true
    },
    foundryDD: {
      type: String,
      default: ''
    },
    errorCSS: {
      type: String,
      default: ''
    },
    inputWidth: {
      type: String,
      default: ''
    },
    inputFont: {
      type: String,
      default: ''
    },
    getSelectedFoundry: {
      type: Function,
      default: () => {}
    },
    from: {
      type: String,
      default: ''
    },
    validateOnMount: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: 'foundry'
    },
    label: {
      type: String,
      default: 'foundry'
    }
  },

  setup() {
    const { errors, validate } = useForm()
    return {
      errors,
      validate
    }
  },

  methods: {
    ...Misc,
    filterPermittedFoundries (foundries, from) {
      const foundriesArray = []
      foundries.forEach((foundry) => {
        const permissionArray = []
        foundry.permissions.forEach((item) => permissionArray.push(item.name))
        if (permissionArray.includes(from)) {
          foundriesArray.push(foundry)
        }
      })
      return foundriesArray
    },
    setFoundryOptions () {
      const permissionsFoundryList = Misc.isValidValue(this.from) ? this.filterPermittedFoundries(this.foundries, this.from) : this.foundries
      const enriched = permissionsFoundryList.map(f => ({
        ...f,
        subTitle: getFoundrySubTitle(f.contractStatus)
      }))
      this.foundry.setOptions({
        obj: enriched,
        value: 'id',
        name: 'name',
        multiple: true
      })
      this.foundryLoaded = true
    },
    updateFoundryValues (val) {
      if (this.foundryLoaded) {
        if (val) {
          if (attemptFoundrySwitch({
            foundryId: val.value,
            isUserAdmin: this.$store.getters['auth/isUserAdmin'],
            store: this.$store,
            revertSelection: () => this.foundry.setValues(getSessionFoundrySelectValues())
          })) return
          this.foundry.state = 'set'
          this.foundry.update(val, () => this.getSelectedFoundry(val))
          this.$events.$emit('get_selectedFoundry', val?.value)
        } else {
          let objVal = { label: this.foundries[0].name, value: this.foundries[0].id }
          this.foundry.setValues({
            obj: objVal,
            value: 'value',
            name: 'label'
          })
        }
        if (this.$router.currentRoute && this.$router.currentRoute.value.name === 'submissions_id') {
          this.$events.$emit('get_foundryContractStatus', val?.value)
        }
      }
      this.foundryLoaded = true
    },
    setFoundriesRoleBased (isFS) {
      let foundryData = {
        foundrySupport: this.foundriesOnFS,
        foundry: this.foundriesOnUser
      }
      let role = isFS ? 'foundrySupport' : 'foundry'
      this.foundries = foundryData[role]
    },
    getSetFoundryLabel () {
      if (this.getUserRoles(this.user) !== 'foundrySupport') {
        let label = window.localStorage.getItem('sessionFoundryName')
        let value = window.localStorage.getItem('sessionFoundryId')
        let val = { label, value }
        this.foundry.setValues({
          obj: val,
          value: 'value',
          name: 'label'
        })
      } else {
        this.foundryLoaded = true
      }
    },
    onFoundrySearchBlur() {
      const isValidSearch = this.foundry.options.some((option) => this.foundry.values === option.label)
      if(!isValidSearch) {
        this.foundry.setValues({
          obj: { label: this.validSelectedFoundry.label, value: this.validSelectedFoundry.value },
          value: 'value',
          name: 'label'
        })
      }
    }
  },

  created () {
    this.setFoundriesRoleBased(this.getUserRoles(this.user) === 'foundrySupport')
    this.setFoundryOptions()
    this.getSetFoundryLabel()
    this.$events?.$on('trigger:validate', () => {
      this.validate()
    })
  },
  beforeUnmount() {
    this.$events?.$off('trigger:validate')
  },
  computed: {
    ...mapGetters('profile', {
      foundriesOnUser: ['foundries'],
      sessionFoundryName: ['sessionFoundryName'],
      sessionFoundryId: ['sessionFoundryId']
    }),
    ...mapGetters('foundrySupport', {
      foundriesOnFS: ['allfoundries']
    }),
    ...mapGetters('auth', ['hasRole', 'user'])
  },
  watch: {
    errors: {
      handler(newVal) {
        if (!isEmpty(newVal)) {
          submissionErrors.value.push(newVal)
        } else {
          submissionErrors.value = submissionErrors.value.filter(error =>
            !Object.hasOwn(error, 'foundry upload')
          )
        }
      },
      immediate: true
    },
    'foundry.values'(newFoundryValue, oldValue) {
      if (Array.isArray(newFoundryValue) && !newFoundryValue.length) {
        this.$nextTick(() => {
          this.foundry.setValues({
            obj: { label: window.localStorage.getItem('sessionFoundryName'), value: window.localStorage.getItem('sessionFoundryId') },
            value: 'value',
            name: 'label'
          })
        })
      }

      if(typeof newFoundryValue === 'string' && newFoundryValue.length && typeof oldValue !== 'string') {
        this.validSelectedFoundry = oldValue
      }
    }
  },
}
</script>

<style lang="scss" src="./stylesheets/index.scss" module></style>
